import React from 'react'
import { useSelector } from 'react-redux'

export default () => {
  const { appSettings } = useSelector((state) => state.app)

  const {
    theme: {
      images: {
        logo: { src, alt, url },
      },
    },
  } = appSettings

  return src ? (
    url ? (
      <a href={url} className="logo">
        <img src={src} alt={__.trans(alt)} />
      </a>
    ) : (
      <div className="logo">
        <img className="logotype" src={src} alt={__.trans(alt)} />
      </div>
    )
  ) : null
}
